var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#B78AF7",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "#DDDDDD",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_7687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19434 11.0701H4.19474C5.31635 13.8277 8.88509 17.6015 12.1479 11.167C13.1424 9.20603 13.8148 7.78625 14.3008 6.75992C15.4096 4.41867 15.5487 4.125 16.3285 4.125C17.2143 4.125 19.8016 7.51647 20.7201 11.1851C20.7195 11.1841 20.719 11.1832 20.7185 11.1823C18.5675 7.86052 17.4701 6.13694 16.4916 6.20217C15.4121 6.27413 14.4772 8.52337 12.4315 13.2059C12.2579 13.5126 12.0947 13.8536 11.944 14.2311C11.7988 14.5401 11.6407 14.943 11.468 15.3965C11.4417 15.4556 11.4153 15.515 11.3888 15.5747C7.82003 22.622 4.80613 14.3384 4.19434 11.0701Z",
    fill: "#9E65FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_921_7687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19434 11.0701H4.19474C5.31635 13.8277 8.88509 17.6015 12.1479 11.167C13.1424 9.20603 13.8148 7.78625 14.3008 6.75992C15.4096 4.41867 15.5487 4.125 16.3285 4.125C17.2143 4.125 19.8016 7.51647 20.7201 11.1851C20.7195 11.1841 20.719 11.1832 20.7185 11.1823C18.5675 7.86052 17.4701 6.13694 16.4916 6.20217C15.4121 6.27413 14.4772 8.52337 12.4315 13.2059C12.2579 13.5126 12.0947 13.8536 11.944 14.2311C11.7988 14.5401 11.6407 14.943 11.468 15.3965C11.4417 15.4556 11.4153 15.515 11.3888 15.5747C7.82003 22.622 4.80613 14.3384 4.19434 11.0701Z",
    fill: "url(#paint0_linear_921_7687)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5288 15.2472C11.5023 15.3062 11.4295 15.3137 11.4027 15.3733C7.7956 22.4102 4.79543 14.222 4.17706 10.9585H3.45605C4.48665 18.0973 5.9689 20.5503 7.99069 20.5449C9.5129 20.5409 10.5992 17.7049 11.3947 15.628C11.4403 15.5088 11.4851 15.3607 11.5288 15.2472Z",
    fill: "url(#paint1_linear_921_7687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7177 11.1836L20.7192 11.1864C20.9828 12.2392 21.1089 13.3148 21.018 14.3397H20.4062C19.2648 11.291 14.8408 8.94875 12.4307 13.2072C14.4764 8.52467 15.4112 6.27541 16.4908 6.20344C17.4693 6.13822 18.5666 7.8618 20.7177 11.1836Z",
    fill: "url(#paint2_linear_921_7687)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7177 11.1836L20.7192 11.1864C20.9828 12.2392 21.1089 13.3148 21.018 14.3397H20.4062C19.2648 11.291 14.8408 8.94875 12.4307 13.2072C14.4764 8.52467 15.4112 6.27541 16.4908 6.20344C17.4693 6.13822 18.5666 7.8618 20.7177 11.1836Z",
    fill: "url(#paint3_linear_921_7687)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_921_7687",
    x1: 8.81522,
    y1: 18.3355,
    x2: 20.8197,
    y2: 9.48577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665552,
    stopColor: "#6200EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_921_7687",
    x1: 5.47343,
    y1: 18.9656,
    x2: 8.35597,
    y2: 16.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193709,
    stopColor: "#4400A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_921_7687",
    x1: 21.5152,
    y1: 14.0181,
    x2: 15.9309,
    y2: 7.14013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#170618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621542,
    stopColor: "#E159E3",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D4B8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_921_7687",
    x1: 20.9893,
    y1: 15.4364,
    x2: 18.7327,
    y2: 5.63297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6200EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806291,
    stopColor: "#4400A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_7687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7418,
    height: 16.75,
    fill: "white",
    transform: "translate(3.45605 4.021)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_921_7687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7418,
    height: 16.75,
    fill: "white",
    transform: "translate(3.45605 4.021)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.526f9c51f72f74fcd1118e2d5e3f8549.svg";
export { ForwardRef as ReactComponent };